export default __webpack_public_path__ + "static/access-map-f63fb554a140d7fe2fae15ecdefaafdb.png";